import React, { useEffect, useState } from "react";
import {
  Typography,
  Spin,
  Select,
  List,
  Rate,
  Image,
  Pagination,
} from "antd";
import { useNavigate } from "react-router-dom";
import feedbackService from "../../services/feedbackService";

const { Option } = Select;
const { Text } = Typography;

interface FeedbackListProps {
  areaData: any;
}

const FeedbackList: React.FC<FeedbackListProps> = ({ areaData }) => {
  const navigate = useNavigate();
  const [feedback, setFeedback] = useState<any[]>([]);
  const [filterPoint, setFilterPoint] = useState<number | null>(null);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [feedbackLoading, setFeedbackLoading] = useState<boolean>(false);
  const [total, setTotal] = useState<number>(0);
  const [nearby, setNearby] = useState<boolean>(false);

  const pageSize = 5;

  useEffect(() => {
    if (areaData?.area?.are_id && areaData?.area?.company_id) {
      fetchFeedback(1, filterPoint, nearby);
    }
  }, [areaData]);

  const fetchFeedback = (
    page: number,
    point: number | null = filterPoint,
    nearbyParam: boolean = nearby
  ) => {
    if (!areaData?.area?.are_id || !areaData?.area?.company_id) return;

    setFeedbackLoading(true);

    const params: any = {
      area_id: areaData.area.are_id,
      company_id: areaData.area.company_id,
      page,
      page_size: pageSize,
    };

    if (nearbyParam) {
      params.nearby = true;
    }

    if (point !== null && point !== undefined) {
      params.point = point;
    }

    feedbackService
      .getFeedback(params)
      .then((dataFeedback: any) => {
        if (dataFeedback.code === 200) {
          setFeedback(dataFeedback.result.feedback || []);
          setTotal(dataFeedback.result.total || 0);
          setCurrentPage(page);
        }
      })
      .catch((error: any) => {
        let description = "Không thể lấy danh sách phản hồi.";
        if (error.message === "timeout") {
          description = "Kết nối đến server có vấn đề. Vui lòng kiểm tra lại mạng.";
        }
        navigate("/qr/error", {
          state: {
            title: "Vui lòng thử lại sau!",
            description,
          },
        });
      })
      .finally(() => {
        setFeedbackLoading(false);
      });
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    fetchFeedback(page, filterPoint, nearby);
  };

  return (
    <div style={{ padding: 5 }}>
      <Spin spinning={feedbackLoading}>
        <div style={{ marginBottom: 16, display: "flex", gap: 16 }}>
          {/* Lọc theo điểm */}
          <div>
            <Text style={{ marginRight: 8 }}>Lọc theo điểm:</Text>
            <Select
              value={filterPoint ?? "all"}
              onChange={(value) => {
                const pointValue = value === "all" ? null : Number(value);
                setFilterPoint(pointValue);
                setFeedback([])
                setCurrentPage(1);
                fetchFeedback(1, pointValue, nearby);
              }}
              style={{ width: 160 }}
            >
              <Option value="all">Tất cả</Option>
              {[5, 4, 3, 2, 1].map((point) => (
                <Option key={point} value={point}>
                  <Rate disabled value={point} style={{ fontSize: 14 }} />
                </Option>
              ))}
            </Select>
          </div>

          {/* Lọc theo khu vực lân cận */}
          <div>
            <Text style={{ marginRight: 8 }}>Khu vực:</Text>
            <Select
              value={nearby ? "nearby" : "current"}
              onChange={(value) => {
                const isNearby = value === "nearby";
                setNearby(isNearby);
                setFeedback([])
                setCurrentPage(1);
                fetchFeedback(1, filterPoint, isNearby);
              }}
              style={{ width: 180 }}
            >
              <Option value="current">Hiện tại</Option>
              <Option value="nearby">Lân cận</Option>
            </Select>
          </div>
        </div>

        <List
          dataSource={feedback}
          renderItem={(item: any) => (
            <List.Item
              style={{
                background: "#f5f5f5",
                padding: 16,
                borderRadius: 12,
                marginBottom: 16,
              }}
            >
              <div style={{ width: "100%" }}>
                {console.log(item, "point")}
                <Rate disabled defaultValue={item.point} />
                {item.created_at && (
                  <div style={{ fontSize: 12, color: "#999", marginTop: 4 }}>
                    {item.created_at}
                  </div>
                )}
                {item.user_send && item.user_send !== "" && (
                  <p style={{ margin: "8px 0", fontSize: 14, fontWeight: 500 }}>
                    Người gửi: {item.user_send}
                  </p>
                )}
                <p style={{ margin: "8px 0", fontSize: 14 }}>
                  Nội dung: {item.feedback || "(Không có nội dung)"}
                </p>
                <p style={{ margin: "8px 0", fontSize: 14 }}>
                  Địa điểm: {item.area_path}
                </p>

                {item.number_file > 0 && item.file?.length > 0 && (
                  <div style={{ display: "flex", gap: 16, marginTop: 8 }}>
                    {item.file.slice(0, 3).map((fileItem: any, idx: number) => (
                      <div key={idx}>
                        <Image
                          src={fileItem.file_base64}
                          alt={fileItem.file_name}
                          width={80}
                          height={80}
                          style={{
                            objectFit: "cover",
                            borderRadius: 8,
                          }}
                        />
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </List.Item>
          )}
        />

        {/* Pagination */}
        {!feedbackLoading && total > pageSize && (
          <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 16 }}>
            <Pagination
              current={currentPage}
              total={total}
              pageSize={pageSize}
              onChange={handlePageChange}
              showSizeChanger={false}
            />
          </div>
        )}

        {!feedbackLoading && feedback.length === 0 && (
          <div style={{ textAlign: "center", color: "#999", marginTop: 16 }}>
            <p style={{ fontSize: 14 }}>Không có phản hồi nào.</p>
          </div>
        )}
      </Spin>
    </div>
  );
};

export default FeedbackList;
